import React, { useState } from "react";
//import { LIST_EXTERNAL_ORGS, GET_ORG, VIEWER_FOR_WIDGET } from './graphql/queries';
//import { useQuery, useLazyQuery } from '@apollo/client';
import { UserTasksTable } from "../components";
import { Tab } from "components/core";
//import { Empty, Spin } from 'antd';

export const UserTasks = (props: any) => {
  const { widgetSettings, taskConfig } = props;
  const { hideTabs } = widgetSettings;
  const taskId = taskConfig?.id;
  const [taskDrawerOpen, setTaskDrawerOpen] = useState(false);
  //const [customFormsToken, setCustomFormsToken] = useState(widgetSettings.customFormsToken);
  const [archived, setArchived] = useState(false);
  // const [orgData, setOrgData] = useState(null);

  // var organizationId = widgetSettings.organizationId || organizations?.[0]?.id;

  const onTaskDrawerOpenToggle = (isOpen) => {
    setTaskDrawerOpen(isOpen);
  };

  /*
  Either of the two, extrnalOrgsData or orgDetails will be valid.
  */
  /*const externalOrgsData = useQuery(LIST_EXTERNAL_ORGS, {
    fetchPolicy: 'no-cache',
    variables: { system: productCode, tenantId, limit: 25, offset: null },
    skip: !tenantId || organizationId,
  });

  const orgDetails = useQuery(GET_ORG, {
    fetchPolicy: 'no-cache',
    variables: { id: organizationId },
    skip: !organizationId,
  });*/

  /*
  Delay the getViewer call till we get the org data
  */
  /*const [getViewer, { data: viewerData }] = useLazyQuery(VIEWER_FOR_WIDGET, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!orgDetails.loading && !externalOrgsData.loading) {
      const singleOrg = orgDetails?.data?.getOrganization;
      const org = externalOrgsData?.data?.listExternalOrganizationsForSystem?.[0] || singleOrg;
      setOrgData(org);
      if (org?.id) {
        getViewer({
          variables: {
            organizationId: org.id,
          },
        });
      } else {
        console.error('Could not get org id from either external orgs or get org call.');
      }
    }
  }, [orgDetails, externalOrgsData]);

  useEffect(() => {
    if (!customFormsToken && viewerData) {
      setCustomFormsToken(viewerData?.getViewerForWidget.customFormsToken);
    }
  }, [viewerData, viewerData?.data]);*/

  return (
    <div style={{ padding: "1.5em 2em 0px" }}>
      <div
        className={`task-drawer-container task-drawer-${taskDrawerOpen ? "open" : "closed"}`}
      >
        <div>
          <h1 className="topLabel">User Tasks</h1>
          <div>
            {hideTabs ? null : (
              <div style={{ display: "flex", paddingLeft: 20 }}>
                <Tab
                  title="All"
                  selected={!archived}
                  setSelected={() => setArchived(false)}
                  hide={taskId ? true : false}
                />
                <Tab
                  title="Archived"
                  selected={archived}
                  setSelected={() => setArchived(true)}
                  hide={taskId ? true : false}
                />
              </div>
            )}
            <UserTasksTable
              onTaskDrawerOpenToggle={onTaskDrawerOpenToggle}
              organization={{ id: widgetSettings.organizationId }}
              //customFormsToken={customFormsToken}
              archived={archived}
              taskConfig={taskConfig}
              //AppSyncConfig={AppSyncConfig}
              widgetSettings={widgetSettings}
            />
          </div>
        </div>
      </div>
      <style>{`
        .task-drawer-closed {
          max-width: 100%;
          width: 100%;
          height:100%;
          transition: all 250ms ease-in-out;
        }
        .task-drawer-open {
          max-width: 100%;
          width: calc(100% - 740px);
          transition: all 250ms ease-in-out;
        }
        div :global(.task-row-open td) {
          background: #d7ebff;
        }
        div :global(.task-row-open:hover td) {
          background: #d7ebff;
        }
      `}</style>
    </div>
  );
};

export default UserTasks;
